import CurriculumList from './CurriculumList';

export default CurriculumList;
